export const FETCH_PARTNERS_NEW_LIST_START = 'FETCH_PARTNERS_NEW_LIST_START';
export const FETCH_PARTNERS_NEW_LIST_SUCCESS = 'FETCH_PARTNERS_NEW_LIST_SUCCESS';
export const FETCH_PARTNERS_NEW_LIST_FAILURE = 'FETCH_PARTNERS_NEW_LIST_FAILURE';